import React, {useState} from "react";
import NavigationMenuSection from "../../menu-items/section/section";
import NavigationMenuItemUrl from "../../menu-items/menu-item-url";
import NavigationMenuItemUser from "../../menu-items/user/menu-item-user";
import NavigationMenuAdd from "../../menu-items/menu-add/menu-add";
import {QuickAddItemType} from "../../../../app/quick-add/@types";
import {MenuComponentProps} from "../const";
import NavigationMenu_ProjectsLocalSettings from "../../local-settings";
import {Feature} from "../../../../core/gd/access-control/feature-access/const";

export default function NavigationMenu_UsersContent(props: MenuComponentProps) {

    const departments       = gd.session.departments.findByCompany(gd.companyId);
    const isManager         = gd.ac.check.company.isManager(gd.companyId);
    const canInviteUsers    = gd.ac.check.company.canInviteUsers(gd.companyId);
    const localSettings     = new NavigationMenu_ProjectsLocalSettings()

    const [collapsedDepartments, setCollapsedDepartments] = useState<string[]>(localSettings.collapsedDepartments)

    const onSectionToggle = (departmentId:ID, isOpen?:boolean)=> {

        if (isOpen) {
            if (gd.user.menu.collapsedDepartments.includes(departmentId)) {
                gd.user.menu.collapsedDepartments.remove(departmentId);
                gd.user.menu.save();
            }
        } else {
            gd.user.menu.collapsedDepartments.push(departmentId);
            gd.user.menu.save();
        }
    }

    const onAddUserClick = (e:React.SyntheticEvent) => {
        if (e) e.stopPropagation();
        // this.hidePopover();
        gd.openNew(QuickAddItemType.USER, {
            type            : 'invite-user',
            organizationId  : gd.companyId
        })
    }

    return (
        <>
            <NavigationMenuSection collapsible={false}>
                <NavigationMenuItemUrl name                 = "Company users"
                                       icon                 = "i5-users"
                                       url                  = "o/users"
                                       navigationSection    = {props.section}/>

                {isManager &&
                    <NavigationMenuItemUrl name                 = "Customers"
                                           icon                 = "i5-customer"
                                           url                  = "o/customers"
                                           navigationSection    = {props.section}
                                           saveUrl              = {false}/>
                }

                <NavigationMenuItemUrl name                 = "Departments"
                                       icon                 = "i5-departments"
                                       url                  = {"o/"+gd.companyId+"/departments"}
                                       navigationSection    = {props.section}
                                       saveUrl              = {false}/>

                {/*no access check needed */}
                <NavigationMenuItemUrl name                 = "Teams"
                                       icon                 = "i5-team"
                                       url                  = {"o/teams"}
                                       navigationSection    = {props.section}
                                       saveUrl              = {false} />


                {(isManager && gd.modules.clockInOut.enabled) &&
                    <NavigationMenuItemUrl name                     = "Clock In/Out"
                                           icon                     = "i5-my-kiosk"
                                           url                      = "o/clock-in-out"
                                           navigationSection        = {props.section}
                                           upgradeRequiredFeature   = {Feature.ATTENDANCE}/>
                }

            </NavigationMenuSection>

            {departments.map((department:any)=>{

                const isExpanded = !collapsedDepartments?.includes(department.id);

                const users = gd.session.companyUsers.findAllByDepartment(department.id)

                return (
                    <NavigationMenuSection
                        key         = {department.id}
                        name        = {department.name}
                        collapsible = {true}
                        counter     = {users.length}
                        isOpen      = {!gd.user.menu.collapsedDepartments.includes(department.id)}
                        onToggle    = {(newIsOpen: boolean)=>onSectionToggle(department.id, newIsOpen)}
                    >
                        {isExpanded && users.map((cu: any) => (
                            <NavigationMenuItemUser
                                key         = {cu.id}
                                companyUser = {cu}
                            />
                        ))}

                        {_.isEmpty(users) &&
                            <div className="no-records">
                                No users found
                            </div>}

                        {canInviteUsers &&
                            <NavigationMenuAdd
                                name    = "New user"
                                onClick = {onAddUserClick}
                            />}

                    </NavigationMenuSection>
                )
            })}
        </>
    )
}
